const tooltips = {
  agencyFee:
    "Set the fee you’re willing to pay a recruitment agency if you hire a candidate they introduce to you, either as a percentage of salary or a fixed cash value. Minimum fee is 10% of candidate’s salary. (Note, if you don’t hire a candidate you won’t pay any fees.)",
  salaryType: "You may specify a fixed salary or salary range.",
  interviewComments: "E.g. Technical test required before the interview.",
  mustHaves: "Type in a new item and press Enter.",
  notificationRecipients:
    "There must be at least one person receiving notifications for this job.",
  agencyBriefing:
    "The more information we can give to the agency, the better the quality of their candidates. An agency brief should detail any of the nitty-gritty not already on the spec that would be essential to finding the perfect candidate. For instance: your top three must-haves, the names of the companies that you would love to see on candidates CVs, where your best-performing employee came from, etc",
};

export { tooltips as default };
